$(document).ready(function() {

  // Repositions the nav dropdowns when necessary
  var navItems = $('.js-nav-item');
  var $window = $(window);

  $('.nav-dropdown-wrapper--learn-fallback').addClass('hidden');

  // Prevent showing scrollbar on load
  if ($('.nav-dropdown-wrapper--learn').length) {
    setupDropdownCssFor($('.nav-dropdown-wrapper--learn'), navItems);
  }

  navItems.hover(function() {
    var navItem = $(this);
    var dropdown = navItem.find('.js-nav-dropdown');

    if(dropdown.hasClass('js-nav-align-right')) {
      setupDropdownCssFor(dropdown, navItem);
    }
    if(navItem.hasClass("js-nav-user")) {
      window.snowplow('trackStructEvent', 'dropdown', 'display', 'user-dropdown');
    } else if (navItem.hasClass("js-nav-learn")) {
      window.snowplow('trackStructEvent', 'dropdown', 'display', 'learn-dropdown');
    }
  }, function() {
    // Setting pointer-events to none is necessary to remove the flickering of
    // the dropdown that's visible when the mouse "exits" the dropdow at the bottom
    var dropdown = $(this).find('.js-nav-dropdown');
  });

  $window.resize(debounce(function() {
    if ($window.width() > 992) {
      $('.js-mobile-nav').modal('hide');
    }
  }, 250));

  function setupDropdownCssFor(dropdown, navItem) {
    var container = $('.js-nav-container');
    // Math.ceil is being used here to make sure containerRight is an integer
    var containerRight = Math.ceil(($window.width() - container.width()) / 2) + container.width();
    var navItemLeft = Math.abs(navItem.offset().left + 1);
    // `-1` because of the box-sizing
    // @http://api.jquery.com/width/
    //
    // `~~` == `Math.floor` but it is faster
    var navItemWidth = ~~(parseFloat(navItem.width() - 1));
    dropdown.addClass('nav-dropdown-wrapper--show');
    dropdown.css({right: -(containerRight - navItemLeft - navItemWidth)});
  }

});
